export const comics = [
  {
    id: 1,
    title: "剑尊归来",
    author: "REDICE STUDIO",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20swordsman%20in%20traditional%20martial%20arts%20robe%2C%20dynamic%20pose%20with%20glowing%20sword%2C%20dramatic%20lighting%2C%20warm%20golden%20and%20crimson%20color%20scheme%2C%20anime%20style%20digital%20art%2C%20clean%20background%20with%20soft%20gradient%2C%20professional%20webtoon%20cover%20quality&width=800&height=1120&seq=comic-cover-01&orientation=portrait",
    category: "武侠",
    rating: 9.7,
    views: "3.2亿",
    status: "连载中",
    updateTime: "2026-07-03",
    latestChapter: "第287话",
    description: "江湖第一剑尊陨落百年后重生归来，却发现当年的仇敌已成为武林至尊。凭借前世记忆与绝世剑法，他将一步步夺回属于自己的一切。这是一部融合了复仇、成长与热血打斗的顶级武侠韩漫，画风精美，打斗场面极具冲击力。",
    tags: ["重生", "武侠", "复仇", "热血"]
  },
  {
    id: 2,
    title: "全知读者视角",
    author: "SING SHONG",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20of%20a%20young%20man%20reading%20a%20mysterious%20book%20with%20glowing%20pages%2C%20surrounded%20by%20fantasy%20elements%2C%20dramatic%20dark%20background%20with%20ethereal%20blue%20and%20gold%20accents%2C%20webtoon%20style%20illustration%2C%20clean%20composition&width=800&height=1120&seq=comic-cover-02&orientation=portrait",
    category: "奇幻",
    rating: 9.8,
    views: "4.5亿",
    status: "连载中",
    updateTime: "2026-07-02",
    latestChapter: "第312话",
    description: "普通上班族金独子偶然成为唯一读完一部超长网络小说的人。当小说中的世界突然变为现实，他凭借对剧情的全知能力，在这个末日世界中展开了惊心动魄的冒险。顶级的韩漫神作，剧情层层递进令人拍案叫绝。",
    tags: ["系统", "末日", "奇幻", "智斗"]
  },
  {
    id: 3,
    title: "我独自升级",
    author: "CHUGONG",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20of%20a%20hooded%20hunter%20with%20glowing%20purple%20eyes%20and%20dark%20armor%2C%20standing%20in%20front%20of%20shadow%20soldiers%2C%20epic%20fantasy%20atmosphere%2C%20dramatic%20contrast%20lighting%2C%20professional%20manhwa%20art&width=800&height=1120&seq=comic-cover-03&orientation=portrait",
    category: "奇幻",
    rating: 9.6,
    views: "5.8亿",
    status: "已完结",
    updateTime: "2025-12-20",
    latestChapter: "第200话（完结）",
    description: "被称为人类最弱兵器的成振宇，在一次双重 dungeon 中濒临死亡后，获得了神秘的升级系统。从最弱到最强，他独自一人踏上了成为世界最强猎人的道路。现象级韩漫，全球累计阅读量破百亿。",
    tags: ["系统", "升级", "爽文", "奇幻"]
  },
  {
    id: 4,
    title: "浪漫城市",
    author: "CARROT STUDIO",
    cover: "https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%20of%20a%20beautiful%20couple%20in%20modern%20city%20setting%2C%20warm%20autumn%20color%20palette%2C%20soft%20lighting%2C%20elegant%20fashion%2C%20romantic%20atmosphere%2C%20webtoon%20style%2C%20clean%20and%20dreamy%20composition&width=800&height=1120&seq=comic-cover-04&orientation=portrait",
    category: "恋爱",
    rating: 9.3,
    views: "2.1亿",
    status: "连载中",
    updateTime: "2026-07-01",
    latestChapter: "第156话",
    description: "在首尔繁华的都市中，两个来自完全不同世界的人相遇了。她是努力打拼的职场新人，他是神秘低调的企业继承人。一段跨越阶层、充满甜蜜与心动的都市浪漫故事就此展开。",
    tags: ["都市", "恋爱", "职场", "甜宠"]
  },
  {
    id: 5,
    title: "暗夜追踪者",
    author: "MOON STUDIO",
    cover: "https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20cover%20of%20a%20detective%20in%20dark%20rainy%20alley%2C%20noir%20atmosphere%2C%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20mysterious%20silhouette%2C%20suspenseful%20mood%2C%20webtoon%20style%20digital%20art%2C%20clean%20composition&width=800&height=1120&seq=comic-cover-05&orientation=portrait",
    category: "悬疑",
    rating: 9.1,
    views: "1.5亿",
    status: "连载中",
    updateTime: "2026-06-30",
    latestChapter: "第89话",
    description: "首尔连环失踪案让整个城市陷入恐慌。前刑警韩志勋接手调查，却发现每一起失踪案背后都隐藏着一个惊人秘密。暗夜之中，追踪者与被追踪者之间的较量才刚刚开始。",
    tags: ["悬疑", "推理", "都市", "犯罪"]
  },
  {
    id: 6,
    title: "神之塔",
    author: "SIU",
    cover: "https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%20of%20a%20mysterious%20tower%20reaching%20into%20the%20sky%2C%20diverse%20characters%20climbing%2C%20epic%20scale%2C%20celestial%20and%20mythical%20elements%2C%20vibrant%20colors%2C%20webtoon%20style%2C%20grand%20adventure%20feel&width=800&height=1120&seq=comic-cover-06&orientation=portrait",
    category: "奇幻",
    rating: 9.5,
    views: "6.3亿",
    status: "连载中",
    updateTime: "2026-07-03",
    latestChapter: "第598话",
    description: "只要登顶神之塔，就能获得任何想要的东西。少年夜为了追寻唯一的挚友蕾哈尔而进入神之塔，在层层试炼中不断成长。宏大的世界观设定，丰富的人物群像，韩漫史上最具影响力的作品之一。",
    tags: ["冒险", "奇幻", "成长", "群像"]
  },
  {
    id: 7,
    title: "王妃的抉择",
    author: "STARFISH",
    cover: "https://readdy.ai/api/search-image?query=Korean%20historical%20romance%20manhwa%20cover%20of%20an%20elegant%20noblewoman%20in%20traditional%20Korean%20hanbok%2C%20palace%20background%2C%20soft%20golden%20lighting%2C%20regal%20atmosphere%2C%20romantic%20and%20dramatic%2C%20webtoon%20style&width=800&height=1120&seq=comic-cover-07&orientation=portrait",
    category: "古风",
    rating: 9.4,
    views: "1.8亿",
    status: "连载中",
    updateTime: "2026-06-29",
    latestChapter: "第134话",
    description: "穿越成为被废黜的王妃，她本打算低调生存，却意外卷入宫廷权力斗争。面对冷酷的皇帝和虎视眈眈的政敌，她将如何运用现代智慧在古朝鲜宫廷中立足？",
    tags: ["穿越", "宫廷", "恋爱", "权谋"]
  },
  {
    id: 8,
    title: "校园异能录",
    author: "BLUE STAR",
    cover: "https://readdy.ai/api/search-image?query=Korean%20school%20action%20manhwa%20cover%20of%20students%20with%20supernatural%20powers%20in%20school%20uniform%2C%20dynamic%20action%20pose%2C%20energy%20effects%2C%20modern%20school%20background%2C%20vibrant%20colors%2C%20webtoon%20style%20illustration&width=800&height=1120&seq=comic-cover-08&orientation=portrait",
    category: "校园",
    rating: 9.0,
    views: "1.2亿",
    status: "连载中",
    updateTime: "2026-06-28",
    latestChapter: "第203话",
    description: "一所看似普通的学校里，隐藏着一群拥有超能力的特殊学生。男主意外觉醒了念动力，从此被卷入超能力者之间的纷争。热血的校园战斗、青春友情的羁绊，都在这里上演。",
    tags: ["校园", "超能力", "热血", "青春"]
  },
  {
    id: 9,
    title: "恶魔的契约",
    author: "DARK MOON",
    cover: "https://readdy.ai/api/search-image?query=Korean%20dark%20fantasy%20manhwa%20cover%20of%20a%20mysterious%20figure%20making%20a%20contract%20with%20a%20demonic%20entity%2C%20gothic%20atmosphere%2C%20dark%20red%20and%20black%20color%20scheme%2C%20supernatural%20elements%2C%20webtoon%20style&width=800&height=1120&seq=comic-cover-09&orientation=portrait",
    category: "奇幻",
    rating: 9.2,
    views: "2.7亿",
    status: "已完结",
    updateTime: "2026-03-15",
    latestChapter: "第178话（完结）",
    description: "为了拯救濒死的妹妹，少年与恶魔签订了契约。获得强大力量的同时，他也必须在规定时间内完成恶魔交付的任务。在人性与力量的边缘，他将做出怎样的选择？",
    tags: ["黑暗", "契约", "奇幻", "悲剧"]
  }
];

export const categories = [
  {
    slug: "wuxia",
    name: "武侠",
    icon: "ri-sword-line",
    description: "江湖恩怨，快意恩仇。汇聚顶级武侠韩漫，热血江湖等你来战！",
    color: "bg-primary-500",
  },
  {
    slug: "fantasy",
    name: "奇幻",
    icon: "ri-magic-line",
    description: "穿越异界，魔法冒险。打开想象力的边界，探索无尽奇幻世界。",
    color: "bg-accent-500",
  },
  {
    slug: "romance",
    name: "恋爱",
    icon: "ri-heart-line",
    description: "怦然心动，甜蜜之恋。最动人的爱情故事在此绽放。",
    color: "bg-secondary-500",
  },
  {
    slug: "suspense",
    name: "悬疑",
    icon: "ri-search-eye-line",
    description: "层层迷雾，真相探寻。反转不断的悬疑推理韩漫，烧脑又过瘾。",
    color: "bg-foreground-600",
  },
  {
    slug: "historical",
    name: "古风",
    icon: "ri-ancient-gate-line",
    description: "穿越古今，宫廷权谋。唯美古风韩漫带你领略别样风情。",
    color: "bg-primary-400",
  },
  {
    slug: "school",
    name: "校园",
    icon: "ri-building-line",
    description: "青春校园，热血成长。那些年在校园里发生的故事，永不过时。",
    color: "bg-accent-400",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "漫画迷小王",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20style%20anime%20profile%20picture%20of%20a%20young%20man%2C%20simple%20style%2C%20clean%20background%2C%20warm%20colors&width=120&height=120&seq=avatar-01&orientation=squarish",
    comment: "韩漫网真的是我用过最好的韩漫阅读平台！更新速度超快，画质高清，分类也很全。最重要的是完全免费，每天都忍不住刷好几个小时！",
    date: "2026-06-28",
  },
  {
    id: 2,
    name: "追更达人小李",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20style%20anime%20profile%20picture%20of%20a%20young%20woman%2C%20simple%20style%2C%20clean%20background%2C%20warm%20colors&width=120&height=120&seq=avatar-02&orientation=squarish",
    comment: "剑尊归来我从第一话追到现在，韩漫网的更新速度从来没让人失望过。界面简洁好用，没有任何乱七八糟的广告，阅读体验极佳！",
    date: "2026-06-25",
  },
  {
    id: 3,
    name: "资深漫友",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20style%20anime%20profile%20picture%20of%20a%20man%20with%20glasses%2C%20simple%20style%2C%20clean%20background%2C%20warm%20colors&width=120&height=120&seq=avatar-03&orientation=squarish",
    comment: "收藏了韩漫网之后就没去过其他漫画网站了。资源太丰富了，从热门大作到小众精品应有尽有。而且每次更新都有推送提醒，太贴心了！",
    date: "2026-06-22",
  },
  {
    id: 4,
    name: "新入坑的小张",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20style%20anime%20profile%20picture%20of%20a%20young%20woman%20smiling%2C%20simple%20style%2C%20clean%20background%2C%20warm%20colors&width=120&height=120&seq=avatar-04&orientation=squarish",
    comment: "朋友推荐了韩漫网，一开始还担心看不懂韩漫，结果发现翻译质量超好！页面设计也很舒服，现在每天通勤路上都在看，已经成为生活必需品了。",
    date: "2026-06-20",
  },
  {
    id: 5,
    name: "老二次元",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20style%20anime%20profile%20picture%20of%20a%20man%20with%20cool%20expression%2C%20simple%20style%2C%20clean%20background%2C%20warm%20colors&width=120&height=120&seq=avatar-05&orientation=squarish",
    comment: "看了十几年动漫，韩漫网的推荐算法真的厉害，总能给我推到我喜欢的类型。全知读者视角就是在上面发现的，现在成了我最爱的作品！",
    date: "2026-06-18",
  },
  {
    id: 6,
    name: "深夜追更人",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20style%20anime%20profile%20picture%20of%20a%20young%20person%2C%20simple%20style%2C%20clean%20background%2C%20warm%20colors&width=120&height=120&seq=avatar-06&orientation=squarish",
    comment: "韩漫网的夜间模式太赞了！晚上躺床上追更完全不会刺眼。而且加载速度很快，翻页流畅，完全不会打断阅读节奏。强烈推荐给大家！",
    date: "2026-06-15",
  },
];

export const faqData = [
  {
    question: "韩漫网上的漫画都是免费的吗？",
    answer: "是的！韩漫网上所有韩国漫画均为免费在线阅读，无需付费或订阅。我们致力于为广大韩漫爱好者提供最优质的免费阅读体验，让每一位读者都能无障碍地享受高清韩国漫画。",
  },
  {
    question: "韩漫网的更新频率是怎样的？",
    answer: "韩漫网与韩国各大漫画平台保持同步更新，热门漫画通常每周更新1-2话。我们会第一时间获取最新章节并进行高质量汉化翻译，确保读者能够及时追更喜爱的作品。",
  },
  {
    question: "韩漫网支持哪些设备阅读？",
    answer: "韩漫网采用响应式设计，完美支持电脑、平板和手机等各类设备。无论您使用什么设备访问，都能获得流畅舒适的阅读体验。推荐使用手机竖屏阅读，效果最佳。",
  },
  {
    question: "如何找到我想看的漫画类型？",
    answer: "您可以通过韩漫网首页的分类导航栏选择感兴趣的漫画类型，包括武侠、奇幻、恋爱、悬疑、古风、校园等多种分类。同时您也可以使用搜索功能，直接输入漫画名称查找。",
  },
  {
    question: "韩漫网上的漫画有版权吗？",
    answer: "韩漫网尊重知识产权，所有漫画内容均来自正版授权合作渠道。我们与多家韩国漫画出版社保持着良好的合作关系，确保平台上的每一部作品都是合法合规的正版内容。",
  },
];